import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { authService } from '@adaptcx/shared/services/auth'
import { useAuthStore } from '@adaptcx/shared/stores/auth'

import './assets/styles/main.css'
// Centralized AdaptCX app shell (Helix workspace design system). After the CSS
// entry so its base/element styles win over Tailwind Preflight.
import '@adaptcx/shared/styles/appshell/index.css'

const app = createApp(App)
app.use(createPinia())

// Silent-refresh before router mounts so a returning reviewer with a valid
// refresh cookie lands authenticated instead of bouncing to /login. Wrapped
// in an async IIFE — top-level await isn't in the Vite browser targets.
// Mirrors dars-officer-portal main.ts.
;(async () => {
  await authService.ensureFreshAccessToken().catch(() => null)
  app.use(router)
  useAuthStore().initFromStorage()
  app.mount('#app')
})()
